import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, Input } from '@angular/core';
import { INavigation, INavigationSub } from '../../interfaces/interface';
import { SubSidebarComponent } from './sub-sidebar/sub-sidebar.component';

class ExpandedIndex {
  first: number | null = null;
  second: number | null = null;
  third: number | null = null;
}

@Component({
  selector: 'app-sidebar',
  imports: [SubSidebarComponent, CommonModule],
  standalone: true,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  @Input({ required: false }) public navigation: INavigation[] = [];

  public lock: boolean = false;
  public expandedIndex: ExpandedIndex = new ExpandedIndex();

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  @HostListener('window:scroll')
  onWindowScroll(): void {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = 57;

    const newTop = Math.max(0, headerHeight - currentScrollTop);
    const newHeight = window.innerHeight - newTop;

    this.updateSidebarPosition(newTop, newHeight);
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    const headerHeight = 57;
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const newTop = Math.max(0, headerHeight - currentScrollTop);
    const newHeight = window.innerHeight - newTop;
    this.updateSidebarPosition(newTop, newHeight);
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.navigation.forEach((item, index) => {
      if (item.sublist && item.sublist.length > 0) {
        item.expanded = true;
      }
    });
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (!this.lock) {
      this.navigation.forEach((v, i) => {
        if (v.sublist && v.sublist.length > 0) {
          v.expanded = false;
        }
      });
    }
  }

  ngOnInit(): void {
    if (localStorage.getItem('lock-sidebar')) {
      this.lock = JSON.parse(localStorage.getItem('lock-sidebar') as string);
    }
    this.lockSidebar();
  }

  public selectSubitem(e: INavigationSub): void {
    this.expandedIndex.second = this.navigation[e.index].sublist[e.subindex].expanded ? e.sublist : null;
    if (e.depth != 0)
      this.navigation[e.index].sublist.forEach((v, i) => {
        if (i != e.subindex) v.expanded = false;
      });
  }

  public lockSidebar(): void {
    let el = this._document.querySelector('.router-content') as HTMLElement;
    if (el) {
      if (this.lock) {
        el.classList.add('locked');
      } else {
        el.classList.remove('locked');
      }
    }
  }

  public lockToggle(): void {
    this.lock = !this.lock;
    localStorage.setItem('lock-sidebar', JSON.stringify(this.lock));
    this.lockSidebar();
  }

  private updateSidebarPosition(top: number, height: number): void {
    const sidebarEl = this._document.querySelector('.menu-wrapper') as HTMLElement;
    const overlayEl = this._document.querySelector('.menu-overlay') as HTMLElement;

    if (sidebarEl) {
      sidebarEl.style.top = `${top}px`;
      sidebarEl.style.height = `${height}px`;
    }

    if (overlayEl) {
      overlayEl.style.top = `${top}px`;
      overlayEl.style.height = `${height}px`;
    }
  }

  public closeMobileMenu(): void {
    if (window.innerWidth <= 768) {
      this.navigation.forEach((v) => {
        if (v.sublist && v.sublist.length > 0) {
          v.expanded = false;
        }
      });
    }
  }
}
